import {Button, TextField} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React, { useState } from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';

const UsernameRecoverySecurityQues = (props: any) => {
  const securityQue = useSelector((state: ReducerState) => state.user.userAccount.questionsForUserNameRecovery);
  const validQue = useSelector((state: ReducerState) => state.user.userRecovery.validQues);
  const [ansArr, updateAnsArr] = useState([]);
  const handlechange = (index: number, val: any) => {
    let newArr: any = [...ansArr]
    newArr[index] = val
    updateAnsArr(newArr)
  }
  const submit = () => {
    ansArr.map((val, index)=> {
      securityQue["Data"].identity.questionList.question[index].questionResponse=val})
    props.onSubmit(securityQue, props.email)
  }
  return (
    <div className="username-recovery__form">
      <h1>Security Questions</h1>
      {securityQue["Data"].identity.questionList.question.map((que:any, index: number) =>(
        <TextField
            className="username-recovery__email-input"
            variant="outlined"
            placeholder={props.placeholder}
            id={que.questionCd.value}
            key={index}
            autoComplete="off"
            label={que.questionCd.codeDes}
            fullWidth
            value={ansArr[que.questionCd.value]}
            onChange={(e) => handlechange(index, e.target.value)}
          />
      ))}

      {(validQue < 3) && 
        <div>
          <Alert severity="error">
            Incorrect answers. Remaining attempts: <b>{validQue}</b>
          </Alert>
          <br/>
        </div>}
     
      <Button
        className="username-recovery__return-to-login-button"
        fullWidth
        onClick={()=>submit()}
        variant="contained"
        color="primary"
      >
        Submit
      </Button>
    </div>
  );
};

export default UsernameRecoverySecurityQues;
